import { PRODUCTS_1P_ORDER } from './PRODUCTS_1P_ORDER';

export async function getProductsOrder(): Promise<string[]> {
	const { ProductsOrder3P } = await import('./3p-product-configs');
	return [...PRODUCTS_1P_ORDER, ...ProductsOrder3P];
}
